var map = {
	"./airoplane 1.jpg": 22007,
	"./android 1.jpg": 70885,
	"./android.jpg": 68448,
	"./apple logo.jpg": 82580,
	"./chat gpt.jpg": 35804,
	"./chrome.jpg": 94855,
	"./fb.jpg": 35097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77495;